export default {
  "en": {
    "referential": {
      "search": "Search by name",
      "attributes": { "name": "Name", "image": "Thumbnail", "family": "Aroma family", "category": "Category" },
      "button": { "add": "Add", "save": "Save", "submit": "Submit", "cancel": "Cancel", "delete": "Delete", "uploadFile": "Choose an image", "deleteImage": "Remove the image" },
      "title": { "image": "Thumbnail", "saveConfirmation": "Saved", "deleteConfirmation": "Delete this entry?", "deleted": "Entry deleted" },
      "validation": { "nameRequired": "A name is required", "imageSize": "The image must be under 2 MB", "imageType": "Only PNG and JPEG are accepted" }
    },
    "billing": {
      "title": "Subscription",
      "plan": { "free": "Free", "premium": "Premium" },
      "none": "No subscription recorded.",
      "subscriptions": "Subscriptions",
      "transactions": "Payments",
      "events": "What the stores and the app sent",
      "onlyErrors": "Refusals and errors only",
      "store": "Store",
      "product": "Product",
      "basePlan": "Base plan",
      "period": "Period",
      "periods": { "month": "Monthly", "year": "Yearly" },
      "status": "Status",
      "autoRenew": "Renews",
      "expiresAt": "Ends",
      "environment": "Environment",
      "ownership": "Ownership",
      "purchasedAt": "Date",
      "price": "Price",
      "revokedAt": "Refunded / revoked",
      "receivedAt": "Received",
      "source": "Source",
      "type": "Type",
      "error": "Refusal",
      "user": "User",
      "active": "On sale",
      "yes": "Yes",
      "no": "No",
      "addProduct": "Add a product",
      "editProduct": "Edit a product",
      "productIdHint": "The identifier exactly as in App Store Connect or the Play Console.",
      "basePlanHint": "Google only: the base plan of the subscription.",
      "activeHint": "An inactive product no longer opens premium to a new purchase; existing subscriptions keep going.",
      "readOnly": "Subscriptions, payments and events are written by the Billing service only, from what the stores say.",
      "grants": {
        "title": "Premium offered",
        "intro": "A premium offered by the Aveine team, without any purchase: the app shows the account as premium, with the premium quotas.",
        "none": "No premium offered.",
        "offer": "Offer the premium",
        "revoke": "Revoke",
        "revokeTitle": "Revoke this premium?",
        "revokeConfirmation": "The account goes back to its paid subscription, or to free, within a few seconds.",
        "revoked": "Premium revoked",
        "revokedAt": "Revoked on",
        "offered": "Premium offered",
        "duration": "Duration",
        "durations": { "1m": "1 month", "3m": "3 months", "1y": "1 year", "date": "Until a date", "none": "No end" },
        "until": "Until",
        "reason": "Reason",
        "reasonHint": "Tester, partner, support gesture…",
        "reasonRequired": "A reason is required",
        "dateRequired": "Choose a date in the future",
        "startsAt": "Start",
        "expiresAt": "End",
        "noEnd": "No end",
        "grantedBy": "Offered by",
        "state": "State",
        "states": { "active": "Active", "upcoming": "Upcoming", "expired": "Ended", "revoked": "Revoked" },
        "all": "All premiums offered",
        "findUser": "Find a user",
        "findUserHint": "By email (exact), part of the profile name, or account id.",
        "query": "Email, name or id",
        "search": "Search",
        "noUser": "No account found.",
        "name": "Name",
        "email": "Email"
      }
    },
    "aiReports": {
      "title": "AI content reports",
      "status": { "open": "To review", "reviewed": "Reviewed", "dismissed": "Dismissed" },
      "kind": { "sommelier_message": "Sommelier reply", "ocr_scan": "Scan card" },
      "reason": { "offensive": "Offensive", "dangerous": "Dangerous", "sexual": "Sexual", "inaccurate": "Inaccurate", "other": "Other" },
      "attributes": { "createdAt": "Reported on", "kind": "Content", "reason": "Reason", "content": "Reported content", "user": "User", "comment": "Comment", "reviewNote": "Review note" },
      "button": { "reviewed": "Mark as reviewed", "dismissed": "Dismiss", "reopen": "Reopen" },
      "prompt": "User's question",
      "reply": "Reported reply",
      "promptRemoved": "Question removed: the account was deleted",
      "anonymized": "Deleted account",
      "reviewedOn": "Handled on {date}",
      "saved": "Report updated"
    },
    "homeContent": {
      "published": "Published",
      "draft": "Draft",
      "attributes": { "published": "Published" },
      "quizReminder": {
        "title": "Daily reminder",
        "intro": "The notification the app schedules every day, for the users who turned the reminder on. The published messages take turns, one per day, in the order of the list. A change reaches each phone the next time the app is opened.",
        "time": "Time (Paris)",
        "hour": "Hour",
        "minute": "Minute",
        "notificationTitle": "Title (optional)",
        "body": "Message",
        "noTitle": "No title",
        "preview": "Preview",
        "edit": "Edit",
        "editTime": "Change the time",
        "addMessage": "Add a message",
        "editMessage": "Edit the message",
        "delete": "Delete",
        "deleteConfirmation": "Delete this message? It leaves the rotation.",
        "inRotation": "Published (in the rotation)",
        "rotation": "One message per day, in turn",
        "noMessage": "No published message: the app shows its own text.",
        "saved": "Reminder saved",
        "missing": "No reminder settings: play the migration 2026-10-16--10--quiz-reminder-settings.sql."
      },
      "featuredRegion": {
        "intro": "The regions offered in the app's tasting profile, in display order. Only published entries are shown in the app.",
        "displayed": "Shown in the app",
        "region": "Region",
        "regionHint": "Leave empty for the « Other regions & wines of the world » entry",
        "label": "Label",
        "labelHint": "Optional: replaces the region's name in the app.",
        "other": "Other regions",
        "noRegion": "No region found",
        "regionTaken": "This region is already in the list.",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "deleteTitle": "Remove this region?",
        "deleteConfirmation": "It will no longer be offered in the app. The users who checked it keep it in their profile."
      },
      "featuredGrape": {
        "intro": "The grapes offered in the app's tasting profile, in display order. The app groups them by color. Only published entries are shown in the app.",
        "grape": "Grape",
        "color": "Group in the app",
        "noGrape": "No grape found",
        "grapeTaken": "This grape is already in the list.",
        "colors": { "red": "Reds", "white": "Whites", "rosé": "Rosés", "orange": "Oranges" },
        "moveUp": "Move up",
        "moveDown": "Move down",
        "deleteTitle": "Remove this grape?",
        "deleteConfirmation": "It will no longer be offered in the app. The users who checked it keep it in their profile."
      },
      "button": {
        "addAnswer": "Add an answer",
        "addTag": "Add a tag",
        "createQuiz": "Add a quiz",
        "createWineOfTheMonth": "Add a wine of the month",
        "createFeaturedRegion": "Add a region",
        "createFeaturedGrape": "Add a grape"
      },
      "quiz": {
        "theme": "Theme",
        "question": "Question",
        "explanation": "Explanation (optional)",
        "answers": "Answers",
        "answerLabel": "Answer {position}",
        "correct": "Right answer",
        "publishedHint": "A quiz is only shown in the app once published.",
        "day": "Release day",
        "dayHint": "One quiz per day: the app shows it on that day only (Paris time). No quiz is shown on a day without one.",
        "openExisting": "Open the existing one",
        "deleteTitle": "Delete this quiz?",
        "deleteConfirmation": "Its answers will be removed with it. Nothing is erased: both can be restored."
      },
      "quizImport": {
        "yes": "yes",
        "no": "no",
        "button": {
          "import": "Import from Excel",
          "template": "Download the Excel template",
          "rules": "How to fill in the Excel file",
          "confirm": "Import {count} quiz(zes)",
          "close": "Close"
        },
        "rules": {
          "title": "Importing quizzes from Excel",
          "intro": "One row per quiz, on the first sheet of the file. The first row holds the column headers below; download the template to start from a ready-made file.",
          "column": "Column",
          "content": "Content",
          "columns": {
            "day": "Release day, required: an Excel date, or text written 2026-11-03 or 03/11/2026.",
            "theme": "Theme, required in French and English.",
            "question": "Question, required in French and English.",
            "explanation": "Explanation shown after the answer, optional.",
            "answers": "From 2 to {max} answers, each in French and English. An empty answer is skipped; the column order is the display order.",
            "correct": "The number (1 to {max}) of the right answer column. There is exactly one right answer.",
            "published": "« oui » or « non ». Empty means « non »: the quiz is imported as a draft."
          },
          "general": {
            "oneRow": "One row = one quiz. Empty rows are ignored.",
            "headers": "Columns are found by their header, in any order. Accents and capitals do not matter; an unknown header blocks the whole file, so a typo is never ignored.",
            "languages": "Other languages are optional: add a column such as question_es or reponse2_de. Accepted languages: {languages}.",
            "dayTaken": "A row whose day already has a quiz is refused: move or delete the existing quiz first.",
            "duplicates": "Two rows on the same day are both refused.",
            "partial": "Nothing is saved before you confirm. Only error-free rows are imported; the others stay listed with their reason.",
            "example": "The template holds an example row: replace it or delete it, or it will be imported too."
          }
        },
        "preview": {
          "title": "Import of {file}",
          "summary": "{valid} row(s) ready to import, {invalid} row(s) with errors (not imported).",
          "result": "{created} quiz(zes) created, {failed} failed.",
          "line": "Row",
          "status": "Status"
        },
        "status": {
          "ready": "Ready",
          "importing": "Importing…",
          "created": "Created"
        },
        "errors": {
          "unreadable": "This file cannot be read. Save it as .xlsx and try again.",
          "emptyFile": "The file holds no sheet.",
          "noRows": "The file holds no quiz: only the header row was found.",
          "unknownColumns": "Unknown column(s): {columns}. Fix the header or remove the column (see the rules, « ? » button).",
          "missingColumn": "Missing column: {column}.",
          "duplicateColumns": "Column(s) present twice: {columns}. Keep only one of each.",
          "dayMissing": "Release day missing.",
          "dayInvalid": "« {value} » is not a valid day: use an Excel date, 2026-11-03 or 03/11/2026.",
          "dayDuplicate": "Same day as row(s) {lines}: one quiz per day.",
          "dayTaken": "This day already has a quiz: « {question} ». Move or delete it first, or pick another day.",
          "dayTakenRace": "This day was taken during the import: nothing was saved for this row.",
          "translationMissing": "{field}: {languages} missing.",
          "answerTranslationMissing": "Answer {number}: {languages} missing.",
          "twoAnswers": "At least two answers are required.",
          "correctMissing": "bonne_reponse is empty: give the number of the right answer.",
          "correctInvalid": "bonne_reponse « {value} » must be a number from 1 to {max}.",
          "correctEmpty": "bonne_reponse points to answer {number}, which is empty.",
          "publishedInvalid": "publie « {value} » must be « oui » or « non ».",
          "saveFailed": "Not saved: {detail}. If the quiz shows up in the list, it was left as a draft: finish it there."
        }
      },
      "wineOfTheMonth": {
        "month": "Month",
        "wine": "Wine",
        "description": "Editorial description",
        "tags": "Tags",
        "tagsHint": "Shown on the card, for instance « 6h aeration » or « Special occasion ».",
        "tagLabel": "Tag {position}",
        "publishedHint": "A pick is only shown in the app once published.",
        "openExisting": "Open the existing one",
        "deleteTitle": "Delete this wine of the month?",
        "deleteConfirmation": "Its tags will be removed with it, and the month becomes free again. Nothing is erased."
      },
      "picker": {
        "hint": "Search by estate or cuvee.",
        "noWine": "No wine found",
        "typeToSearch": "Type at least two characters",
        "unnamedWine": "Unnamed wine"
      },
      "validation": {
        "translationsRequired": "{languages} are required",
        "twoAnswers": "At least two answers are required",
        "oneCorrect": "One answer must be marked as the right one",
        "answerTranslations": "Every answer needs its FR and EN translations",
        "tagTranslations": "Every tag needs its FR and EN translations",
        "monthRequired": "A month is required",
        "dayRequired": "A release day is required",
        "dayTaken": "{day} already has a quiz: « {quiz} ». Move it or delete it first, or pick another day.",
        "dayTakenRace": "This day was taken while you were editing. Reload and pick another day.",
        "monthTaken": "{month} already has a wine of the month: {wine}. Delete it first, or pick another month.",
        "monthTakenRace": "This month was taken while you were editing. Reload and pick another month.",
        "wineRequired": "A wine is required"
      }
    },
    "bottleImage": {
      "title": "Official bottle picture",
      "help": "Shown in the middle of the mobile wine sheet. Kept at full resolution — this is not the label.",
      "inherited": "Inherited from the cuvee. Uploading one here overrides it for this vintage only.",
      "choose": "Choose a picture",
      "remove": "Remove",
      "saved": "Bottle picture saved",
      "removed": "Bottle picture removed",
      "tooBig": "The picture must be under 5 MB",
      "wrongType": "Only PNG and JPEG are accepted"
    },
    "title": {
      "welcomeSentence": "You must login in order to use the intranet",
      "aveine": "Aveine",
      "language": "Language:",
      "unknownError": "Unknown Error",
      "editProfile": "Edit Profile",
      "wineFormAlreadyProcessed": "Wine form already processed",
      "menu": {
        "navigation": "Navigation",
        "home": "Home",
        "invitations": "Pending invitations",
        "invoices": "Invoices management",
        "wines": {
          "title": "Wines",
          "add": "Add a wine",
          "list": "Wines",
          "wineForms": "Wine Forms",
          "uncheckedWines": "Unchecked wines",
          "wineTemplates": "Wine groups",
          "commentValidation": "Comment validation"
        },
        "users": {
          "title": "Users",
          "index": "Users",
          "ambassador": "Ambassadors",
          "superAmbassador": "Super Ambassadors",
          "domain": "Domains",
          "invitation": "Invitation Management",
          "invoice": "Invoice Management"
        },
        "shop": {
          "sales": "Shopify Sales",
          "stats": "Sales Stats"
        },
        "misc-ressources": {
          "title": "Miscellaneous",
          "aroma": "Aromas",
          "foodPairing": "Food pairings",
          "grape": "Grapes",
          "region": "Regions",
          "appellation": "Appellations",
          "company": "Companies"
        },
        "home-content": {
          "title": "App content",
          "quiz": "Quizzes",
          "wineOfTheMonth": "Wine of the month",
          "aiReports": "AI reports",
          "featuredRegions": "Profile regions",
          "featuredGrapes": "Profile grapes"
        },
        "billing": {
          "title": "Subscriptions",
          "products": "Store products",
          "events": "Store events",
          "grants": "Offer a subscription"
        },
        "tech-management": {
          "title": "Tech Management",
          "changelogs": "Changelogs",
          "announcements": "Announcements",
          "aerators": "Aerators"
        }
      },
      "page": {
        "aroma": {
          "create": "Add an aroma",
          "update": "Edit an aroma",
          "list": "Aromas"
        },
        "quiz": {
          "create": "Add a quiz",
          "update": "Edit a quiz",
          "list": "Quizzes"
        },
        "wineOfTheMonth": {
          "create": "Add a wine of the month",
          "update": "Edit a wine of the month",
          "list": "Wines of the month"
        },
        "featuredRegion": {
          "create": "Add a region",
          "update": "Edit a region",
          "list": "Profile regions"
        },
        "featuredGrape": {
          "create": "Add a grape",
          "update": "Edit a grape",
          "list": "Profile grapes"
        },
        "foodPairing": {
          "create": "Add a food pairing",
          "update": "Edit a food pairing",
          "list": "Food pairings"
        },
        "home": "Home",
        "wine": {
          "create": "Add a wine",
          "update": "Update a wine",
          "list": "List of wines",
          "read": "Wine sheet"
        },
        "wineComments": {
          "list": "Wine Comments to validate"
        },
        "wineTemplate": {
          "update": "Update a wine group",
          "list": "List of wine groups",
          "read": "Wine group information"
        },
        "wineForm": {
          "list": "List of wine forms",
          "validate": "Validate a wine"
        },
        "uncheckedWines": {
          "list": "List of unchecked wines",
          "check": "Check a wine"
        },
        "domain": {
          "create": "Add a domain",
          "update": "Update a domain",
          "list": "List of domains",
          "read": "Domain sheet",
          "invite": "Invite a domain",
          "duplicateManagement": "Duplicate domain management"
        },
        "ambassador": {
          "create": "Add an ambassadeur",
          "update": "Update an ambassadeur",
          "list": "List of ambassadeurs",
          "read": "Ambassadeur sheet",
          "invite": "Invite an ambassadeur"
        },
        "superAmbassador": {
          "create": "Add a super ambassadeur",
          "update": "Update a super ambassadeur",
          "list": "List of super ambassadeurs",
          "read": "Super ambassadeur sheet",
          "invite": "Invite a super ambassadeur"
        },
        "grape": {
          "create": "Add a grape",
          "update": "update a grape",
          "list": "List of grapes",
          "read": "Grape sheet"
        },
        "region": {
          "create": "Add a region",
          "update": "update a region",
          "list": "List of regions",
          "read": "Region sheet",
          "duplicateManagement": "Duplicate region management"
        },
        "company": {
          "create": "Add a company",
          "update": "Update a company",
          "list": "List of companies",
          "read": "Company sheet"
        },
        "appellation": {
          "create": "Add an appellation",
          "list": "List of appellations",
          "update": "Update an appellation",
          "read": "Appellation Sheet"
        },
        "sales": {
          "read": "Sales",
          "declaredSales": "Declared Sales"
        },
        "discountCodes": {
          "list": "Discount codes for shop",
          "add": "Create a new discount code for shop",
          "update": "Update a discount code for shop"
        },
        "changelog": {
          "create": "Add a changelog",
          "update": "Update a changelog",
          "list": "List of changelogs"
        },
        "announcement": {
          "create": "Create an announcement",
          "update": "Update an announcement",
          "list": "List of announcement"
        },
        "aerators": {
          "createBootloader": "Create a Bootloader",
          "createFirmware": "Create a firmware",
          "createHardware": "Create a hardware",
          "createPackage": "Create a package",
          "createProgrammed": "Create a programmed",
          "updateBootloader": "Update a Bootloader",
          "updateFirmware": "Update a firmware",
          "updateHardware": "Update a hardware",
          "updatePackage": "Update a package",
          "updateProgrammed": "Update a programmed",
        },
        "invitation": "Pending Invitations",
        "invoices": "Invoices management",
        "createInvoice": "Issue an invoice",
        "invoiceInformation": "Invoicing information",
        "errors": {
          "pageNotFound": "Error 404",
          "pageNotFoundMessage": "Oops, the page you are trying to access doesn't exist!"
        }
      },
      "aerators": {
        "aerators": "Aerators",
        "firmwares": "Firmwares",
        "bootloaders": "Bootloaders",
        "packages": "DFU Packages",
        "hardwares": "Hardwares",
        "programmed": "Programmed Updates",
        "searchSerial": "Search by serial",
        "searchUser": "Search by User"
      },
      "footer": {
        "version": "Version",
        "copyright": "Copyright © 2019 Aveine."
      }
    },
    "profile": {
      "editProfile": "Edit Profile",
      "name": "User name",
      "description": "Description",
      "language": {
        "en": "English",
        "fr": "Français"
      },
      "button": {
        "deleteImage": "Remove avatar",
        "submit": "Submit",
        "uploadFile": "Upload a file",
        "cancel": "Cancel" 
      }
    },
    "validation": {
      "wineFormAlreadyProcessed": "This wine form has already been processed and is not available anymore"
    },
    "sales": {
      "title": "My sales",
      "discountCode": "Discount code",
      "currency": "Currency",
      "unlockedMoney": "Declarable income available",
      "lockedMoney": "Locked income",
      "unlockedAt": "unlocked at",
      "declare": "Declare"
    },
    "dashboard": {
      "oneWeek": "1 week",
      "oneMonth": "1 month",
      "threeMonths": "3 months",
      "oneYear": "1 year",
      "wineForm": "Wines to Validate",
      "ambassadeurs": "Ambassadeurs",
      "domains": "Domains",
      "wines": "Wines",
      "remaining": "Remaining",
      "commentsRemaining": "Comment(s) Pending",
      "activity": "Activity",
      "lastSales": "Last Sales",
      "shop": "shop",
      "errorDatePicker": "Starting date shouldn't be greater than ending date"
    }
  },
  "fr": {
    "referential": {
      "search": "Rechercher par nom",
      "attributes": { "name": "Nom", "image": "Vignette", "family": "Famille aromatique", "category": "Catégorie" },
      "button": { "add": "Ajouter", "save": "Enregistrer", "submit": "Valider", "cancel": "Annuler", "delete": "Supprimer", "uploadFile": "Choisir une image", "deleteImage": "Retirer l'image" },
      "title": { "image": "Vignette", "saveConfirmation": "Enregistré", "deleteConfirmation": "Supprimer cette entrée ?", "deleted": "Entrée supprimée" },
      "validation": { "nameRequired": "Un nom est obligatoire", "imageSize": "L'image doit peser moins de 2 Mo", "imageType": "Seuls les PNG et JPEG sont acceptés" }
    },
    "billing": {
      "title": "Abonnement",
      "plan": { "free": "Gratuit", "premium": "Premium" },
      "none": "Aucun abonnement enregistré.",
      "subscriptions": "Abonnements",
      "transactions": "Paiements",
      "events": "Ce que les stores et l'app ont envoyé",
      "onlyErrors": "Refus et erreurs seulement",
      "store": "Store",
      "product": "Produit",
      "basePlan": "Base plan",
      "period": "Période",
      "periods": { "month": "Mensuel", "year": "Annuel" },
      "status": "Statut",
      "autoRenew": "Se renouvelle",
      "expiresAt": "Échéance",
      "environment": "Environnement",
      "ownership": "Détention",
      "purchasedAt": "Date",
      "price": "Prix",
      "revokedAt": "Remboursé / révoqué",
      "receivedAt": "Reçu le",
      "source": "Origine",
      "type": "Type",
      "error": "Refus",
      "user": "Utilisateur",
      "active": "En vente",
      "yes": "Oui",
      "no": "Non",
      "addProduct": "Ajouter un produit",
      "editProduct": "Modifier un produit",
      "productIdHint": "L'identifiant exactement tel que dans App Store Connect ou la Play Console.",
      "basePlanHint": "Google seulement : le base plan de l'abonnement.",
      "activeHint": "Un produit inactif n'ouvre plus le premium à un nouvel achat ; les abonnements en cours continuent.",
      "readOnly": "Les abonnements, les paiements et les événements ne sont écrits que par le service Billing, d'après les stores.",
      "grants": {
        "title": "Premium offert",
        "intro": "Un premium offert par l'équipe Aveine, sans achat : l'app affiche le compte en premium, avec les quotas premium.",
        "none": "Aucun premium offert.",
        "offer": "Offrir le premium",
        "revoke": "Retirer",
        "revokeTitle": "Retirer ce premium ?",
        "revokeConfirmation": "Le compte revient à son abonnement payé, ou au gratuit, d'ici quelques secondes.",
        "revoked": "Premium retiré",
        "revokedAt": "Retiré le",
        "offered": "Premium offert",
        "duration": "Durée",
        "durations": { "1m": "1 mois", "3m": "3 mois", "1y": "1 an", "date": "Jusqu'à une date", "none": "Sans fin" },
        "until": "Jusqu'au",
        "reason": "Motif",
        "reasonHint": "Testeur, partenaire, geste du support…",
        "reasonRequired": "Un motif est obligatoire",
        "dateRequired": "Choisissez une date à venir",
        "startsAt": "Début",
        "expiresAt": "Fin",
        "noEnd": "Sans fin",
        "grantedBy": "Offert par",
        "state": "État",
        "states": { "active": "En cours", "upcoming": "À venir", "expired": "Terminé", "revoked": "Retiré" },
        "all": "Tous les premiums offerts",
        "findUser": "Trouver un utilisateur",
        "findUserHint": "Par email (exact), une partie du nom de profil, ou l'identifiant du compte.",
        "query": "Email, nom ou identifiant",
        "search": "Rechercher",
        "noUser": "Aucun compte trouvé.",
        "name": "Nom",
        "email": "Email"
      }
    },
    "aiReports": {
      "title": "Signalements des contenus IA",
      "status": { "open": "À traiter", "reviewed": "Traités", "dismissed": "Écartés" },
      "kind": { "sommelier_message": "Réponse du sommelier", "ocr_scan": "Fiche de scan" },
      "reason": { "offensive": "Offensant", "dangerous": "Dangereux", "sexual": "Sexuel", "inaccurate": "Faux", "other": "Autre" },
      "attributes": { "createdAt": "Signalé le", "kind": "Contenu", "reason": "Motif", "content": "Contenu signalé", "user": "Utilisateur", "comment": "Commentaire", "reviewNote": "Note de traitement" },
      "button": { "reviewed": "Marquer comme traité", "dismissed": "Écarter", "reopen": "Rouvrir" },
      "prompt": "Question de l'utilisateur",
      "reply": "Réponse signalée",
      "promptRemoved": "Question retirée : le compte a été supprimé",
      "anonymized": "Compte supprimé",
      "reviewedOn": "Traité le {date}",
      "saved": "Signalement mis à jour"
    },
    "homeContent": {
      "published": "Publié",
      "draft": "Brouillon",
      "attributes": { "published": "Publié" },
      "quizReminder": {
        "title": "Rappel quotidien",
        "intro": "La notification que l'app planifie chaque jour, pour les utilisateurs qui ont activé le rappel. Les messages publiés tournent, un par jour, dans l'ordre de la liste. Un changement atteint chaque téléphone à la prochaine ouverture de l'app.",
        "time": "Heure (Paris)",
        "hour": "Heure",
        "minute": "Minute",
        "notificationTitle": "Titre (facultatif)",
        "body": "Message",
        "noTitle": "Sans titre",
        "preview": "Aperçu",
        "edit": "Modifier",
        "editTime": "Changer l'heure",
        "addMessage": "Ajouter un message",
        "editMessage": "Modifier le message",
        "delete": "Supprimer",
        "deleteConfirmation": "Supprimer ce message ? Il sort de la rotation.",
        "inRotation": "Publié (dans la rotation)",
        "rotation": "Un message par jour, à tour de rôle",
        "noMessage": "Aucun message publié : l'app affiche son propre texte.",
        "saved": "Rappel enregistré",
        "missing": "Aucun réglage du rappel : jouer la migration 2026-10-16--10--quiz-reminder-settings.sql."
      },
      "featuredRegion": {
        "intro": "Les régions proposées dans le profil de goût de l'app, dans l'ordre d'affichage. Seules les entrées publiées apparaissent dans l'app.",
        "displayed": "Affiché dans l'app",
        "region": "Région",
        "regionHint": "Laisser vide pour l'entrée « Autres régions & vins du monde »",
        "label": "Libellé",
        "labelHint": "Facultatif : remplace le nom de la région dans l'app.",
        "other": "Autres régions",
        "noRegion": "Aucune région trouvée",
        "regionTaken": "Cette région est déjà dans la liste.",
        "moveUp": "Monter",
        "moveDown": "Descendre",
        "deleteTitle": "Retirer cette région ?",
        "deleteConfirmation": "Elle ne sera plus proposée dans l'app. Les utilisateurs qui l'avaient cochée la gardent dans leur profil."
      },
      "featuredGrape": {
        "intro": "Les cépages proposés dans le profil de goût de l'app, dans l'ordre d'affichage. L'app les range par couleur. Seules les entrées publiées apparaissent dans l'app.",
        "grape": "Cépage",
        "color": "Groupe dans l'app",
        "noGrape": "Aucun cépage trouvé",
        "grapeTaken": "Ce cépage est déjà dans la liste.",
        "colors": { "red": "Rouges", "white": "Blancs", "rosé": "Rosés", "orange": "Oranges" },
        "moveUp": "Monter",
        "moveDown": "Descendre",
        "deleteTitle": "Retirer ce cépage ?",
        "deleteConfirmation": "Il ne sera plus proposé dans l'app. Les utilisateurs qui l'avaient coché le gardent dans leur profil."
      },
      "button": {
        "addAnswer": "Ajouter une réponse",
        "addTag": "Ajouter une étiquette",
        "createQuiz": "Ajouter un quizz",
        "createWineOfTheMonth": "Ajouter un vin du mois",
        "createFeaturedRegion": "Ajouter une région",
        "createFeaturedGrape": "Ajouter un cépage"
      },
      "quiz": {
        "theme": "Thème",
        "question": "Question",
        "explanation": "Explication (facultative)",
        "answers": "Réponses",
        "answerLabel": "Réponse {position}",
        "correct": "Bonne réponse",
        "publishedHint": "Un quizz n'apparaît dans l'application qu'une fois publié.",
        "day": "Jour de sortie",
        "dayHint": "Un quizz par jour : l'application le montre ce jour-là seulement (heure de Paris). Un jour sans quizz, aucun n'est affiché.",
        "openExisting": "Ouvrir celui qui existe",
        "deleteTitle": "Supprimer ce quizz ?",
        "deleteConfirmation": "Ses réponses seront retirées avec lui. Rien n'est effacé : les deux restent restaurables."
      },
      "quizImport": {
        "yes": "oui",
        "no": "non",
        "button": {
          "import": "Importer depuis Excel",
          "template": "Télécharger le modèle Excel",
          "rules": "Comment remplir le fichier Excel",
          "confirm": "Importer {count} quizz",
          "close": "Fermer"
        },
        "rules": {
          "title": "Importer des quizz depuis Excel",
          "intro": "Une ligne par quizz, sur la première feuille du fichier. La première ligne porte les en-têtes de colonnes ci-dessous ; téléchargez le modèle pour partir d'un fichier prêt à remplir.",
          "column": "Colonne",
          "content": "Contenu",
          "columns": {
            "day": "Jour de sortie, obligatoire : une date Excel, ou du texte écrit 2026-11-03 ou 03/11/2026.",
            "theme": "Thème, obligatoire en français et en anglais.",
            "question": "Question, obligatoire en français et en anglais.",
            "explanation": "Explication affichée après la réponse, facultative.",
            "answers": "De 2 à {max} réponses, chacune en français et en anglais. Une réponse vide est ignorée ; l'ordre des colonnes est l'ordre d'affichage.",
            "correct": "Le numéro (1 à {max}) de la colonne de la bonne réponse. Il y a exactement une bonne réponse.",
            "published": "« oui » ou « non ». Vide vaut « non » : le quizz est importé en brouillon."
          },
          "general": {
            "oneRow": "Une ligne = un quizz. Les lignes vides sont ignorées.",
            "headers": "Les colonnes sont repérées par leur en-tête, dans n'importe quel ordre. Accents et majuscules ne comptent pas ; un en-tête inconnu bloque tout le fichier, pour qu'une faute de frappe ne passe jamais inaperçue.",
            "languages": "Les autres langues sont facultatives : ajoutez une colonne comme question_es ou reponse2_de. Langues acceptées : {languages}.",
            "dayTaken": "Une ligne dont le jour a déjà un quizz est refusée : déplacez ou supprimez d'abord le quizz existant.",
            "duplicates": "Deux lignes sur le même jour sont refusées toutes les deux.",
            "partial": "Rien n'est enregistré avant votre confirmation. Seules les lignes sans erreur sont importées ; les autres restent listées avec leur raison.",
            "example": "Le modèle contient une ligne d'exemple : remplacez-la ou supprimez-la, sinon elle sera importée aussi."
          }
        },
        "preview": {
          "title": "Import de {file}",
          "summary": "{valid} ligne(s) prête(s) à importer, {invalid} ligne(s) en erreur (non importées).",
          "result": "{created} quizz créé(s), {failed} en échec.",
          "line": "Ligne",
          "status": "État"
        },
        "status": {
          "ready": "Prête",
          "importing": "Import…",
          "created": "Créé"
        },
        "errors": {
          "unreadable": "Ce fichier est illisible. Enregistrez-le en .xlsx et réessayez.",
          "emptyFile": "Le fichier ne contient aucune feuille.",
          "noRows": "Le fichier ne contient aucun quizz : seule la ligne d'en-têtes a été trouvée.",
          "unknownColumns": "Colonne(s) inconnue(s) : {columns}. Corrigez l'en-tête ou retirez la colonne (voir les règles, bouton « ? »).",
          "missingColumn": "Colonne manquante : {column}.",
          "duplicateColumns": "Colonne(s) présente(s) deux fois : {columns}. N'en gardez qu'une de chaque.",
          "dayMissing": "Jour de sortie manquant.",
          "dayInvalid": "« {value} » n'est pas un jour valide : utilisez une date Excel, 2026-11-03 ou 03/11/2026.",
          "dayDuplicate": "Même jour que la ou les lignes {lines} : un seul quizz par jour.",
          "dayTaken": "Ce jour a déjà un quizz : « {question} ». Déplacez-le ou supprimez-le d'abord, ou choisissez un autre jour.",
          "dayTakenRace": "Ce jour a été pris pendant l'import : rien n'a été enregistré pour cette ligne.",
          "translationMissing": "{field} : {languages} manquant.",
          "answerTranslationMissing": "Réponse {number} : {languages} manquant.",
          "twoAnswers": "Il faut au moins deux réponses.",
          "correctMissing": "bonne_reponse est vide : indiquez le numéro de la bonne réponse.",
          "correctInvalid": "bonne_reponse « {value} » doit être un numéro de 1 à {max}.",
          "correctEmpty": "bonne_reponse désigne la réponse {number}, qui est vide.",
          "publishedInvalid": "publie « {value} » doit valoir « oui » ou « non ».",
          "saveFailed": "Non enregistré : {detail}. Si le quizz apparaît dans la liste, il est resté en brouillon : terminez-le depuis la liste."
        }
      },
      "wineOfTheMonth": {
        "month": "Mois",
        "wine": "Vin",
        "description": "Description éditoriale",
        "tags": "Étiquettes",
        "tagsHint": "Affichées sur la carte, par exemple « 6h d'aération » ou « Grande occasion ».",
        "tagLabel": "Étiquette {position}",
        "publishedHint": "Un choix n'apparaît dans l'application qu'une fois publié.",
        "openExisting": "Ouvrir celui qui existe",
        "deleteTitle": "Supprimer ce vin du mois ?",
        "deleteConfirmation": "Ses étiquettes seront retirées avec lui, et le mois redeviendra libre. Rien n'est effacé."
      },
      "picker": {
        "hint": "Cherchez par domaine ou par cuvée.",
        "noWine": "Aucun vin trouvé",
        "typeToSearch": "Saisissez au moins deux caractères",
        "unnamedWine": "Vin sans nom"
      },
      "validation": {
        "translationsRequired": "{languages} sont obligatoires",
        "twoAnswers": "Il faut au moins deux réponses",
        "oneCorrect": "Une réponse doit être désignée comme la bonne",
        "answerTranslations": "Chaque réponse doit porter ses traductions FR et EN",
        "tagTranslations": "Chaque étiquette doit porter ses traductions FR et EN",
        "monthRequired": "Le mois est obligatoire",
        "dayRequired": "Le jour de sortie est obligatoire",
        "dayTaken": "Le {day} a déjà un quizz : « {quiz} ». Déplacez-le ou supprimez-le d'abord, ou choisissez un autre jour.",
        "dayTakenRace": "Ce jour a été pris pendant votre saisie. Rechargez et choisissez un autre jour.",
        "monthTaken": "{month} a déjà un vin du mois : {wine}. Supprimez-le d'abord, ou choisissez un autre mois.",
        "monthTakenRace": "Ce mois a été pris pendant votre saisie. Rechargez et choisissez un autre mois.",
        "wineRequired": "Le vin est obligatoire"
      }
    },
    "bottleImage": {
      "title": "Photo officielle de la bouteille",
      "help": "Affichée au milieu de la fiche vin mobile. Conservée en pleine résolution — ce n'est pas l'étiquette.",
      "inherited": "Héritée de la cuvée. En déposer une ici ne vaudra que pour ce millésime.",
      "choose": "Choisir une image",
      "remove": "Retirer",
      "saved": "Photo enregistrée",
      "removed": "Photo retirée",
      "tooBig": "L'image doit peser moins de 5 Mo",
      "wrongType": "Seuls les PNG et JPEG sont acceptés"
    },
    "title": {
      "welcomeSentence": "Veuillez vous connecter afin d'utiliser l'intranet d'Aveine",
      "aveine": "Aveine",
      "language": "Langue:",
      "unknownError": "Erreur inconnue",
      "editProfile": "Edition du Profil",
      "wineFormAlreadyProcessed": "Formulaire vin déjà traité",
      "menu": {
        "navigation": "Navigation",
        "home": "Accueil",
        "invitations": "Invitations en attente",
        "invoices": "Factures Pro",
        "miscellaneous": "Divers",
        "wines": {
          "title": "Vins",
          "add": "Ajouter un vin",
          "list": "Vins",
          "wineForms": "Vins à valider",
          "uncheckedWines": "Vins à vérifier",
          "wineTemplates": "Groupes vin",
          "commentValidation": "Commentaires à valider"
        },
        "users": {
          "title": "Utilisateurs",
          "index": "Utilisateurs",
          "ambassador": "Ambassadeurs",
          "superAmbassador": "Super Ambassadeurs",
          "domain": "Domaines",
          "invitation": "Gèrer les Invitations",
          "invoice": "Gérer les Factures"
        },
        "shop": {
          "sales": "Ventes Shopify",
          "stats": "Statistiques"
        },
        "misc-ressources": {
          "title": "Ressources Diverses",
          "aroma": "Arômes",
          "foodPairing": "Accords mets-vins",
          "grape": "Cépages",
          "region": "Régions",
          "appellation": "Appellations",
          "company": "Sociétés"
        },
        "home-content": {
          "title": "Contenu application",
          "quiz": "Quizz",
          "wineOfTheMonth": "Vin du mois",
          "aiReports": "Signalements IA",
          "featuredRegions": "Régions du profil",
          "featuredGrapes": "Cépages du profil"
        },
        "billing": {
          "title": "Abonnements",
          "products": "Produits des stores",
          "events": "Événements des stores",
          "grants": "Offrir un abonnement"
        },
        "tech-management": {
          "title": "Gestion Tech",
          "changelogs": "Changelogs",
          "announcements": "Annonces",
          "aerators": "Aérateurs"
        }
      },
      "page": {
        "aroma": {
          "create": "Ajouter un arôme",
          "update": "Modifier un arôme",
          "list": "Liste des arômes"
        },
        "quiz": {
          "create": "Ajouter un quizz",
          "update": "Modifier un quizz",
          "list": "Quizz"
        },
        "wineOfTheMonth": {
          "create": "Ajouter un vin du mois",
          "update": "Modifier un vin du mois",
          "list": "Vins du mois"
        },
        "featuredRegion": {
          "create": "Ajouter une région",
          "update": "Modifier une région",
          "list": "Régions du profil"
        },
        "featuredGrape": {
          "create": "Ajouter un cépage",
          "update": "Modifier un cépage",
          "list": "Cépages du profil"
        },
        "foodPairing": {
          "create": "Ajouter un accord mets-vins",
          "update": "Modifier un accord mets-vins",
          "list": "Liste des accords mets-vins"
        },
        "home": "Accueil",
        "wine": {
          "create": "Ajouter un vin",
          "update": "Modifier un vin",
          "list": "Liste des vins",
          "read": "Fiche vin"
        },
        "wineComments": {
          "list": "Commentaires à valider"
        },
        "wineTemplate": {
          "update": "Modifier un group vin",
          "list": "Liste des groupes vins",
          "read": "Informations groupe vin"
        },
        "wineForm": {
          "list": "Liste des vins à valider",
          "validate": "Valider un vin"
        },
        "uncheckedWines": {
          "list": "Liste des vins à vérifier",
          "check": "Vérifier un vin"
        },
        "domain": {
          "create": "Ajouter un domaine",
          "update": "Modifier un domaine",
          "list": "Liste des domaines",
          "read": "Fiche domaine",
          "invite": "Inviter un domaine",
          "duplicateManagement": "Gestion des domaines doublons"
        },
        "ambassador": {
          "create": "Ajouter un ambassadeur",
          "update": "Modifier un ambassadeur",
          "list": "Liste des ambassadeurs",
          "read": "Fiche ambassadeur",
          "invite": "Inviter un ambassadeur"
        },
        "superAmbassador": {
          "create": "Ajouter un super ambassadeur",
          "update": "Modifier un super ambassadeur",
          "list": "Liste des super ambassadeurs",
          "read": "Fiche super ambassadeur",
          "invite": "Inviter un super ambassadeur"
        },
        "grape": {
          "create": "Ajouter un cépage",
          "update": "Modifier un cépage",
          "list": "Liste des cépages",
          "read": "Fiche cépage"
        },
        "region": {
          "create": "Ajouter une région",
          "update": "Modifier une région",
          "list": "Liste des régions",
          "read": "Fiche région",
          "duplicateManagement": "Gestion des regions doublons"
        },
        "company": {
          "create": "Ajouter une société",
          "update": "Modifier une société",
          "list": "Liste des sociétés",
          "read": "Fiche societé"
        },
        "appellation": {
          "create": "Ajouter une appellation",
          "list": "Liste des appellations",
          "update": "Modifier une appellation",
          "read": "Fiche appellation"
        },
        "sales": {
          "read": "Ventes",
          "declaredSales": "Ventes Déclarées"
        },
        "discountCodes": {
          "list": "Codes promos du shop",
          "add": "Création d'un code promo pour le shop",
          "update": "Modifier un code promo pour le shop"
        },
        "changelog": {
          "create": "Ajouter un changelog",
          "update": "Modifier un changelog",
          "list": "Liste des changelogs"
        },
        "announcement": {
          "create": "Créer une annonce",
          "update": "Modifier une annonce",
          "list": "Liste des annonces"
        },
        "aerators": {
          "createBootloader": "Créer un Bootloader",
          "createFirmware": "Créer un firmware",
          "createHardware": "Créer un hardware",
          "createPackage": "Créer un package",
          "createProgrammed": "Créer une programmed update",
          "updateBootloader": "Mettre à jour un Bootloader",
          "updateFirmware": "Mettre à jour un firmware",
          "updateHardware": "Mettre à jour un hardware",
          "updatePackage": "Mettre à jour un package",
          "updateProgrammed": "Mettre à jour une programmed update",
        },
        "invitation": "Invitations en Attente",
        "invoices": "Gestion des Factures Pro",
        "createInvoice": "Emettre une facture",
        "invoiceInformation": "Informations de facturation",
        "errors": {
          "pageNotFound": "Erreur 404",
          "pageNotFoundMessage": "Oups, la page que vous recherchez n'existe pas !"
        }
      },
      "aerators": {
        "aerators": "Aerateurs",
        "firmwares": "Firmwares",
        "bootloaders": "Bootloaders",
        "packages": "DFU Packages",
        "hardwares": "Hardwares",
        "programmed": "Programmed Updates",
        "searchSerial": "Chercher par Serial",
        "searchUser": "Chercher par Utilisateur"
      },
      "footer": {
        "version": "Version",
        "copyright": "Copyright © 2019 Aveine."
      }
    },
    "profile": {
      "editProfile": "Edition du Profil",
      "name": "Nom utilisateur",
      "description": "Description",
      "language": {
        "en": "English",
        "fr": "Français"
      },
      "button": {
        "deleteImage": "Retirer l'avater",
        "submit": "Valider",
        "uploadFile": "Choisir un fichier",
        "cancel": "Annuler" 
      }
    },
    "validation": {
      "wineFormAlreadyProcessed": "Ce formulaire vin a déjà été traité et n'est plus valable"
    },
    "sales": {
      "title": "Mes ventes",
      "discountCode": "Code promo",
      "currency": "Devise",
      "unlockedMoney": "Montant déclarable disponible",
      "lockedMoney": "Montant verrouillé",
      "unlockedAt": "dévérouillé le",
      "declare": "Déclarer"
    },
    "dashboard": {
      "oneWeek": "1 semaine",
      "oneMonth": "1 mois",
      "threeMonths": "3 mois",
      "oneYear": "1 an",
      "wineForm": "Vins à Valider",
      "ambassadeurs": "Ambassadeurs",
      "domains": "Domaines",
      "wines": "Vins",
      "remaining": "Restant",
      "commentsRemaining": "Commentaire(s) à valider",
      "activity": "Activité",
      "lastSales": "Dernières Ventes",
      "shop": "boutique",
      "errorDatePicker": "La date de début de devrait pas être plus récente que la date de fin"
    }
  }
}